'use strict'

require('core-js/modules/es.array.at')
require('core-js/modules/es.array.flat')
require('core-js/modules/es.array.flat-map')
require('core-js/modules/es.object.from-entries')
require('core-js/modules/es.promise.all-settled')
require('core-js/modules/es.promise.finally')
require('intersection-observer')
require('resize-observer-polyfill/dist/ResizeObserver.global')
